export default "__VITE_ASSET__68c24390__"